<template>
  <v-card>
    <v-expansion-panels>
      <v-expansion-panel class="mx-4">
        <v-expansion-panel-header>
          <div class="mx-auto text-center">
            <toolbar-titles :title="`Reporte ${data.name}`" class="pt-5" />
            <p>{{ data.description }}</p>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-container>
            <v-layout row wrap>
              <!-- Datos de la fecha, hora y usuario -->
              <v-flex xs12 md6 class="d-flex">
                <div>
                  <h4>Parámetros:</h4>
                  <div v-for="(param, index) in dataReports" :key="index">
                    {{ param.name }}: {{ param.items }}
                  </div>
                </div>
              </v-flex>

              <v-flex xs12 md6 class="d-flex justify-end">
                <div>
                  <div>Fecha: {{ currentDate }}</div>
                  <div>Hora: {{ timestamp }}</div>
                  <div>Usuario: {{ operator }}</div>
                </div>
              </v-flex>

              <!-- Parámetros -->
            </v-layout>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card class="mx-4">
      <v-card-title
        style="background-color: #82a1d0"
        background-color="primary"
        class="d-flex justify-center align-center"
      >
        <v-text-field
          dense
          solo
          v-model="search"
          append-icon="mdi-magnify"
          :label="$tc('commons.search')"
          single-line
          hide-details
          class="search"
        ></v-text-field>
        <v-spacer></v-spacer>
        <div class="d-flex justify-start border ma-0">
          <v-menu
            v-model="btnConfigColumns.menu"
            :close-on-content-click="false"
            nudge-width="400px"
            offset-x
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="white"
                    dark
                    icon
                    @click="toggleColumnMenu"
                    v-bind="attrs"
                    v-on="on"
                    class="btn-table ma-auto ml-1"
                    small
                  >
                    <v-icon size="20">{{ btnConfigColumns.icon }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ btnConfigColumns.tooltip }}</span>
              </v-tooltip>
            </template>
            <v-card>
              <v-text-field
                v-model="columnFilter"
                placeholder="Buscar columnas"
                outlined
                dense
                hide-details
                class="pa-2 pb-0 ma-0"
              ></v-text-field>
              <div
                style="
                  min-width: 250px;
                  max-height: 250px;
                  overflow-y: scroll;
                  scrollbar-width: unset;
                "
                class="pa-2 pb-0 ma-0"
                hide-details
              >
                <div
                  v-if="filteredColumns.length === 0"
                  class="text-center px-2 pb-2"
                >
                  <span>No hay resultados que coincidan con la búsqueda</span>
                </div>
                <div v-else>
                  <v-list>
                    <v-list-item
                      v-for="header in filteredColumns"
                      :key="header.value"
                      class="mt-n5 mb-n5"
                    >
                      <v-switch
                        @click="toggleColumnVisibility(header.value)"
                        outlined
                        small
                        inset
                      >
                      </v-switch>
                      <v-list-item-title>{{ header.text }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
            </v-card>
          </v-menu>
          <!-- Ordenar por grupos -->
          <v-menu
            v-model="btnConfigColumnsGroup.menu"
            :close-on-content-click="false"
            nudge-width="400px"
            offset-x
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="white"
                    dark
                    icon
                    @click="toggleColumnMenuGroup"
                    v-bind="attrs"
                    v-on="on"
                    class="btn-table ma-auto ml-1"
                    small
                  >
                    <v-icon size="20">{{ btnConfigColumnsGroup.icon }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ btnConfigColumnsGroup.tooltip }}</span>
              </v-tooltip>
            </template>
            <v-card>
              <v-text-field
                v-model="columnFilterGroup"
                placeholder="Buscar columnas"
                outlined
                dense
                hide-details
                class="pa-2 pb-0 ma-0"
              ></v-text-field>
              <div
                style="
                  min-width: 250px;
                  max-height: 250px;
                  overflow-y: scroll;
                  scrollbar-width: unset;
                "
                class="pa-2 pb-0 ma-0"
                hide-details
              >
                <div
                  v-if="filteredColumnsGroup.length === 0"
                  class="text-center px-2 pb-2"
                >
                  <span>No hay resultados que coincidan con la búsqueda</span>
                </div>
                <div v-else>
                  <v-list>
                    <v-list-item
                      v-for="header in filteredColumnsGroup"
                      :key="header.value"
                      class="mt-n5 mb-n5"
                    >
                      <v-switch
                        @click="toggleGroupBy(header.value)"
                        outlined
                        small
                        inset
                      >
                      </v-switch>
                      <v-list-item-title>{{ header.text }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
            </v-card>
          </v-menu>

          <v-col cols="auto pa-0">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="white" dark icon class="btn-table ma-1" small>
                    <v-icon
                      size="20"
                      class="mx-auto"
                      id="icon-add"
                      v-bind="attrs"
                      v-on="on"
                      @click="downloadCSV"
                      >mdi-download-circle-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("commons.dowloadCSV") }}</span>
              </v-tooltip>
            </div>
          </v-col>

          <v-col cols="auto pa-0">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="white" dark icon class="btn-table ma-1" small>
                    <v-icon
                      size="20"
                      class="mx-auto"
                      id="icon-add"
                      v-bind="attrs"
                      v-on="on"
                      @click="viewFilterPdf = true"
                      >mdi-file-pdf-box
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("commons.dowloadPDF") }}</span>
              </v-tooltip>
            </div>
          </v-col>

          <v-col cols="auto pa-0">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="white" dark icon class="btn-table ma-1" small>
                    <v-icon
                      size="20"
                      class="mx-auto"
                      id="icon-add"
                      v-bind="attrs"
                      v-on="on"
                      @click="downloadExcel"
                      >mdi-file-excel-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("commons.dowloadEXCEL") }}</span>
              </v-tooltip>
            </div>
          </v-col>
        </div>
      </v-card-title>

      <v-divider />

      <template v-if="!groupedBy.length">
        <v-data-table
          :search="search"
          :headers="getVisibleHeaders"
          :items="rows"
          class="mb-4"
          hide-default-footer
          disable-pagination
          dense
          fixed-header
          :height="calculateMaxHeight"
          style="min-width: 100%"
          :calculate-widths="true"
        />
      </template>

      <template v-else>
        <v-col style="height: 60vh; overflow-y: scroll; scrollbar-width: unset">
          <GroupedRow
            :search="search"
            v-for="(group, i) in groupedRows"
            :key="i"
            :group="group"
            :headers="filteredHeaders"
        /></v-col>
      </template>
    </v-card>
    <div class="mt-5 d-flex justify-center pb-5">
      <v-btn class="bt-exit" @click="backReport">{{
        $tc("newController.close")
      }}</v-btn>
    </div>
    <v-dialog v-model="viewFilterPdf" max-width="400px" persistent>
      <v-card class="pa-4">
        <v-card-subtitle class="pa-0 pb-3"> Salto de pagina </v-card-subtitle>
        <v-select
          outlined
          dense
          class="my-0"
          :items="filteredHeaders"
          label="Criterio"
          v-model="jumpCriterion"
        />
        <div class="d-flex justify-space-between">
          <v-btn
            class="bt-exit"
            @click="(viewFilterPdf = false), (jumpCriterion = '')"
          >
            {{ $tc("editRegistrations.cancel") }}</v-btn
          >
          <v-btn
            @click="
              downloadPDF(), (viewFilterPdf = false), (jumpCriterion = '')
            "
            class="bt-acept"
          >
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import reports from "../../store/reportes/reports";
import Sortable from "sortablejs";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import ToolbarTitles from "../Complement/ToolbarTitles.vue";
import GroupedRow from "./commons/GroupedRow.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";

pdfMake.vfs = pdfFonts.vfs;

export default {
  name: "TableExecute",
  components: {
    ToolbarTitles,
    GroupedRow,
  },
  props: {
    parameters: Array,
    data: Object,
  },
  data() {
    return {
      expanded: false,
      currentDate: "",
      timestamp: "",
      operator: "",
      search: "",
      tableKey: 0,
      btnConfigColumnsGroup: {
        menu: false,
        icon: "fas fa-layer-group",
        tooltip: "Agrupar por",
      },
      btnConfigColumns: {
        menu: false,
        icon: "mdi-cog",
        tooltip: "Columnas",
      },
      groupedBy: [],
      columnFilter: "",
      columnFilterGroup: "",
      viewFilterPdf: false,
      jumpCriterion: "",
    };
  },
  mounted() {
    // Obtener la fecha de hoy
    this.currentDate = new Date().toLocaleDateString();
    // Obtener el timestamp actual
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    this.timestamp = `${hours}:${minutes}`;
    // Obtener el operador del localStorage (debes definir cómo se guarda en localStorage)
    this.operator = localStorage.getItem("name");
  },
  computed: {
    groupedRows() {
      return this.groupData(this.rows, this.groupedBy);
    },
    groupableHeaders() {
      return this.getVisibleHeaders;
    },
    filteredHeaders() {
      return this.getVisibleHeaders.filter(
        (h) => !this.groupedBy.includes(h.value),
      );
    },
    dataReports() {
      const params = reports.state.executeParams?.params;
      if (!Array.isArray(params)) return [];

      return params.map((item) => {
        const name = item.name
          ? this.capitalizeFirstLetter(item.name)
          : "Parametro no definido";

        const val = item.label !== undefined ? item.label : item.value;
        let items;

        if (Array.isArray(val)) {
          items = val
            .map((i) =>
              typeof i === "object" && i !== null
                ? i.name ?? "Parametro no definido"
                : i,
            )
            .join(", ");
        } else if (typeof val === "object" && val !== null) {
          items = val.name || "Parametro no definido";
        } else if (
          typeof val === "string" &&
          moment(val, "YYYY-MM-DD", true).isValid()
        ) {
          items = moment(val, "YYYY-MM-DD").format("DD-MM-YYYY");
        } else {
          items = val ?? "Parametro no definido";
        }

        return { name, items };
      });
    },
    headers() {
      return reports.state.headers.map((header) => ({
        text: header,
        value: header,
        class: "primary secondary--text",
        sortable: false,
      }));
    },
    rows() {
      return reports.state.rows;
    },
    showTableExecute() {
      return reports.state.showTableExecute;
    },
    visibleColumns() {
      const initialColumns = {};
      this.headers.forEach((header) => {
        initialColumns[header.value] = true;
      });
      return { ...initialColumns, ...reports.state.visibleColumns };
    },

    getVisibleHeaders() {
      return this.headers.filter((header) => {
        return this.visibleColumns[header.value];
      });
    },

    calculateMaxHeight() {
      switch (true) {
        case this.rows.length >= 10:
          return "60vh";
      }
    },
    filteredColumns() {
      const filterText = this.columnFilter.toLowerCase();
      return this.headers.filter((column) => {
        return column.text.toLowerCase().includes(filterText);
      });
    },
    filteredColumnsGroup() {
      const filterText = this.columnFilterGroup.toLowerCase();
      return this.headers.filter((column) => {
        return column.text.toLowerCase().includes(filterText);
      });
    },
  },
  methods: {
    toggleGroupBy(header) {
      const index = this.groupedBy.indexOf(header);
      if (index !== -1) {
        this.groupedBy.splice(index, 1); // quitar agrupación
      } else {
        this.groupedBy.push(header); // agregar agrupación
      }
    },
    groupData(data, fields) {
      const [field, ...rest] = fields;

      if (!field) {
        return [
          {
            label: `Resultados (Total: ${data.length})`,
            children: data,
          },
        ];
      }

      const grouped = {};
      data.forEach((item) => {
        const key = item[field] || "N/A";
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(item);
      });

      return Object.entries(grouped).map(([key, children]) => ({
        label: `${field}: ${key}`,
        children: this.groupData(children, rest),
      }));
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
    toggleColumnVisibility(columnName) {
      const isVisible = !this.visibleColumns[columnName];
      reports.commit("setVisibleColumns", {
        columnName,
        isVisible,
      });
    },
    toggleColumnMenuGroup() {
      this.btnConfigColumnsGroup.menu = !this.btnConfigColumnsGroup.menu;
    },
    toggleColumnMenu() {
      this.btnConfigColumns.menu = !this.btnConfigColumns.menu;
    },
    saveColumnOrder(newIndex, oldIndex) {
      const columnMoved = this.getVisibleHeaders.splice(oldIndex, 1)[0];
      this.getVisibleHeaders.splice(newIndex, 0, columnMoved);
      this.rows.forEach((item) => {
        const movedData = item[columnMoved.value];
        delete item[columnMoved.value];
        item[columnMoved.value] = movedData;
      });
      this.tableKey++;
      this.$forceUpdate();
    },

    backReport() {
      this.search = "";
      localStorage.setItem("dataReport", false);
      this.groupedBy = [];
      reports.commit("setHeaders", []);
      reports.commit("setRows", []);
      reports.commit("setShowTableExecute", false);
      reports.commit("setResetVisibleColumns");
    },
    downloadCSV() {
      const visibleRows = this.rows.map((row) => {
        const visibleRow = {};
        Object.keys(row).forEach((key) => {
          if (this.visibleColumns[key]) {
            visibleRow[key] = row[key];
          }
        });
        return visibleRow;
      });
      const csvContent = Papa.unparse(visibleRows);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "reporte.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    downloadExcel() {
      const visibleRows = this.rows.map((row) => {
        const visibleRow = {};
        Object.keys(row).forEach((key) => {
          if (this.visibleColumns[key]) {
            visibleRow[key] = row[key];
          }
        });
        return visibleRow;
      });
      const ws = XLSX.utils.json_to_sheet(visibleRows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
      this.downloadFile(
        new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
        "reporte.xlsx",
        "application/octet-stream;",
      );
    },

    /*     downloadPDF() {
  const columnCount = Object.keys(this.visibleColumns).filter(
    (key) => this.visibleColumns[key]
  ).length;

  const isLandscape = columnCount > 6;

  const doc = new jsPDF({
    orientation: isLandscape ? "landscape" : "portrait",
    unit: "mm",
    format: "a4",
  });

  const maxWidth = doc.internal.pageSize.getWidth() - 20;

  const title = doc.splitTextToSize(this.data.name, maxWidth);
  const descriptionText = doc.splitTextToSize(this.data.description, maxWidth);

  const paddingTop = 2;
  const lineHeight = 2;
  const titleHeight = title.length * lineHeight;
  const descriptionHeight = descriptionText.length * lineHeight;
  const contentY = paddingTop + Math.max(titleHeight, 5);

  // Título centrado
  doc.setFontSize(18);
  doc.setTextColor(63, 81, 181);
  doc.text(title, doc.internal.pageSize.getWidth() / 2, contentY, {
    align: "center",
  });

  // Descripción centrada
  doc.setFontSize(12);
  doc.text(
    descriptionText,
    doc.internal.pageSize.getWidth() / 2,
    contentY + titleHeight + 5,
    { align: "center" }
  );

  // Información a la izquierda
  const today = new Date().toLocaleDateString();
  const time = new Date().toLocaleTimeString();
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text(`Fecha: ${today}`, 5, 4);
  doc.text(`Hora: ${time}`, 5, 8);
  doc.text(`Operador: ${this.operator}`, 5, 12);

  // Información a la derecha desde dataReports
  if (Array.isArray(this.dataReports)) {
    const rightX = doc.internal.pageSize.getWidth() - 5;
    this.dataReports.forEach((item, index) => {
      const y = 4 + index * 4;
      doc.text(`${item.name}: ${item.items}`, rightX, y, { align: "right" });
    });
  }

  // Columnas y filas
  const visibleColumns = Object.keys(this.visibleColumns).filter(
    (key) => this.visibleColumns[key]
  );
  const columns = visibleColumns.map((key) => ({
    header: key,
    dataKey: key,
  }));

  const rows = this.rows.map((row) => {
    const visibleRow = {};
    columns.forEach((column) => {
      visibleRow[column.dataKey] = row[column.dataKey];
    });
    return visibleRow;
  });

  const yPos = contentY + titleHeight + descriptionHeight + 10;

  // Tabla
  doc.autoTable({
    startY: yPos,
    head: [columns.map((column) => column.header)],
    body: rows.map((row) => columns.map((column) => row[column.dataKey])),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      overflow: "linebreak",
      halign: "center",
      valign: "middle",
      textColor: [0, 0, 0],
      lineColor: [63, 81, 181],
      lineWidth: 0.1,
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      fontSize: 9,
    },
    columnStyles: Object.fromEntries(
      columns.map((col) => [col.dataKey, { cellWidth: 35 }])
    ),
    margin: { left: 5, right: 5 },
    tableLineColor: [63, 81, 181],
    tableLineWidth: 0.1,
    didDrawCell: function (data) {
      data.cell.styles.lineWidth = 0.1;
      data.cell.styles.lineColor = [63, 81, 181];
    },
  });

  doc.save("reporte.pdf");
},
 */
    formatLabel(key) {
      return key
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
    },

    downloadPDF() {
      const columnCount = Object.keys(this.visibleColumns).filter(
        (key) => this.visibleColumns[key],
      ).length;

      const isLandscape = columnCount > 6;

      const doc = new jsPDF({
        orientation: isLandscape ? "landscape" : "portrait",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const maxWidth = pageWidth - 20;

      const title = doc.splitTextToSize(this.data.name, maxWidth);
      const descriptionText = doc.splitTextToSize(
        this.data.description,
        maxWidth,
      );

      const lineHeight = 2;
      const paddingTop = 2;
      const titleHeight = title.length * lineHeight;
      const descriptionHeight = descriptionText.length * lineHeight;

      const contentY = paddingTop + Math.max(titleHeight, 5);

      // Título y descripción centrados
      doc.setFontSize(16);
      doc.setTextColor(63, 81, 181);
      doc.text(title, pageWidth / 2, contentY, {
        align: "center",
      });

      doc.setFontSize(10);
      const descriptionY = contentY + titleHeight + 5;
      doc.text(descriptionText, pageWidth / 2, descriptionY, {
        align: "center",
      });

      const leftX = 5;
      const rightX = pageWidth - 5;
      const lineHeightParam = 4;

      // Datos fijos (DERECHA)
      const now = new Date();
      const fecha = now.toLocaleDateString();
      const hora = now.toLocaleTimeString();
      const infoFixed = [
        `Fecha: ${fecha}`,
        `Hora: ${hora}`,
        `Operador: ${this.operator}`,
      ];

      const maxWidthRight = rightX - 5;
      let currentYRight = 4;
      let maxYSideContent = 0;

      infoFixed.forEach((text) => {
        const lines = doc.splitTextToSize(text, maxWidthRight);
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);

        lines.forEach((line, lineIndex) => {
          doc.text(line, rightX, currentYRight + lineIndex * lineHeightParam, {
            align: "right",
          });
        });

        const blockHeight = lines.length * lineHeightParam;
        maxYSideContent = Math.max(
          maxYSideContent,
          currentYRight + blockHeight - lineHeightParam,
        );
        currentYRight += blockHeight;
      });

      // Datos de dataReports (IZQUIERDA) — con salto de línea según ancho
      if (
        localStorage.getItem("dataReport") &&
        localStorage.getItem("dataReport") === "false"
      ) {
        const maxWidthLeft = pageWidth - leftX - 5;
        let currentYLeft = 4;

        if (Array.isArray(this.dataReports)) {
          this.dataReports.forEach((item) => {
            const fullText = `${this.formatLabel(item.name)}: ${item.items}`;
            const lines = doc.splitTextToSize(fullText, maxWidthLeft);

            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);

            lines.forEach((line, lineIndex) => {
              doc.text(
                line,
                leftX,
                currentYLeft + lineIndex * lineHeightParam,
                {
                  align: "left",
                },
              );
            });

            const blockHeight = lines.length * lineHeightParam;
            maxYSideContent = Math.max(
              maxYSideContent,
              currentYLeft + blockHeight - lineHeightParam,
            );
            currentYLeft += blockHeight;
          });
        }
      }

      const bottomOfDescription = descriptionY + descriptionHeight;
      const bottomOfSideContent = maxYSideContent + 2;
      let startYTable = Math.max(bottomOfDescription, bottomOfSideContent);

      const dataReportsCount = this.dataReports?.length || 0;
      const extraSpacing = Math.max(0, (dataReportsCount - 5) * 1);
      startYTable += 1 + extraSpacing;

      const visibleColumns = Object.keys(this.visibleColumns).filter(
        (key) => this.visibleColumns[key],
      );
      const columns = visibleColumns.map((key) => ({
        header: key,
        dataKey: key,
      }));

      const rows = this.rows.map((row) => {
        const visibleRow = {};
        columns.forEach((column) => {
          visibleRow[column.dataKey] = row[column.dataKey];
        });
        return visibleRow;
      });

      if (
        this.jumpCriterion != "" &&
        visibleColumns.includes(this.jumpCriterion)
      ) {
        const groupedRows = {};
        this.rows.forEach((row) => {
          const key = row[this.jumpCriterion] || "Sin Nombre";
          if (!groupedRows[key]) groupedRows[key] = [];
          const visibleRow = {};
          columns.forEach((column) => {
            visibleRow[column.dataKey] = row[column.dataKey];
          });
          groupedRows[key].push(visibleRow);
        });

        let first = true;
        for (const nombre in groupedRows) {
          if (!first) doc.addPage();
          first = false;

          doc.setFontSize(10);
          doc.setTextColor(33, 33, 33);
          doc.text(`Criterio por: ${nombre}`, 5, startYTable);

          doc.autoTable({
            startY: startYTable + 5,
            head: [columns.map((column) => column.header)],
            body: groupedRows[nombre].map((row) =>
              columns.map((column) => row[column.dataKey]),
            ),
            styles: {
              fontSize: 7,
              cellPadding: 1,
              overflow: "linebreak",
              halign: "center",
              valign: "middle",
              textColor: [0, 0, 0],
              lineColor: [63, 81, 181],
              lineWidth: 0.1,
            },
            headStyles: {
              fillColor: [63, 81, 181],
              textColor: [255, 255, 255],
              fontSize: 7,
            },
            columnStyles: Object.fromEntries(
              columns.map((col) => [col.dataKey, { cellWidth: 35 }]),
            ),
            margin: { left: 5, right: 5 },
            tableLineColor: [63, 81, 181],
            tableLineWidth: 0.1,
          });
        }
      } else {
        doc.autoTable({
          startY: startYTable,
          head: [columns.map((column) => column.header)],
          body: rows.map((row) => columns.map((column) => row[column.dataKey])),
          styles: {
            fontSize: 7,
            cellPadding: 1,
            overflow: "linebreak",
            halign: "center",
            valign: "middle",
            textColor: [0, 0, 0],
            lineColor: [63, 81, 181],
            lineWidth: 0.1,
          },
          headStyles: {
            fillColor: [63, 81, 181],
            textColor: [255, 255, 255],
            fontSize: 7,
          },
          columnStyles: Object.fromEntries(
            columns.map((col) => [col.dataKey, { cellWidth: 35 }]),
          ),
          margin: { left: 5, right: 5 },
          tableLineColor: [63, 81, 181],
          tableLineWidth: 0.1,
        });
      }

      doc.save("reporte.pdf");
    },

    downloadFile(content, filename, type) {
      const blob = new Blob([content], { type });
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
  },
  directives: {
    sortableColumns: {
      inserted(el, binding) {
        const table = el.querySelector("table");
        const headerRow = table.querySelector("thead tr");
        const sortableHeaders = Array.from(headerRow.children);
        const options = {
          animation: 150,
          ghostClass: "sortable-ghost",
          onEnd: function (event) {
            const newIndex = event.newIndex;
            const oldIndex = event.oldIndex;
            binding.value(newIndex, oldIndex);
          },
        };
        Sortable.create(headerRow, options);
      },
    },
  },
};
</script>

<style scoped>
.search {
  max-width: 500px;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.button-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.active {
  background-color: #82a1d0 !important;
  color: white;
}
::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
#icon-add {
  color: #ffffff;
  margin-right: 8px;
}
</style>
